import type { ReactNode } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import type { Role } from '../lib/types';
import { errorText } from '../lib/errors';
import { Splash } from './ui';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { ready, session } = useAuth();
  const loc = useLocation();
  if (!ready) return <Splash />;
  if (!session) return <Navigate to={`/signin?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return <>{children}</>;
}

function MeError({ error }: { error: unknown }) {
  return (
    <div className="splash">
      <div className="stack center" style={{ maxWidth: 340, padding: 16 }}>
        <p className="err">{errorText(error)}</p>
        <button className="btn ghost" onClick={() => location.reload()}>Try again</button>
      </div>
    </div>
  );
}

/** Resident pages need the email to be linked to a flat. */
export function RequireFlat({ children }: { children: ReactNode }) {
  const { me, meLoading, meError } = useAuth();
  const loc = useLocation();
  if (meLoading) return <Splash />;
  if (meError) return <MeError error={meError} />;
  if (!me?.flat) return <Navigate to={`/link?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return <>{children}</>;
}

export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { hasRole, meLoading, meError } = useAuth();
  if (meLoading) return <Splash />;
  if (meError) return <MeError error={meError} />;
  if (!hasRole(...roles)) {
    return (
      <div className="splash">
        <div className="stack center" style={{ maxWidth: 360, padding: 16, justifyItems: 'center' }}>
          <p className="display" style={{ fontSize: 22 }}>This page is for Food Committee volunteers</p>
          <p className="muted">If you are volunteering, ask a Food Committee admin to add your email.</p>
          <Link className="btn primary" to="/">Go to My passes</Link>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
